module.exports = __webpack_public_path__ + "static/media/C20-0733_COVID-19_FR_Mobile_767x845.30205ca2.jpg";